import { render, staticRenderFns } from "./sela-new.vue?vue&type=template&id=8ecf5eea"
import script from "./sela-new.vue?vue&type=script&lang=js"
export * from "./sela-new.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports